import { StandardComp } from "../atoms/standardComp";
import { HorizontalLayout, HorizontalPageLayout, VerticalLayout, VerticalPageLayout } from "../components/layout";
import { useContext, useEffect, useState } from "react";
import { icon } from "../functions/icons";
import { Alert } from "../components/alert";
import { getAPI } from "../api/api";
import { ReviewFactory } from "../factory/reviewFactory";
import { PageContext } from "../App";
import { ScoreOverview } from "../components/ScoreOverview"
import { is } from "date-fns/locale";
import { TitleAtom } from "../atoms/titleAtom";
import { IconButton } from "../atoms/buttons";
import { IconAtom } from "../atoms/iconAtom";

export default function Review({ pageSwap, errorScoreMessage, scoreData, loading, exercises }) {
    const [collapsedIndexes, setCollapsedIndexes] = useState({});
    const getQuizTypeName = (quizType) => {
        switch (parseInt(quizType)) {
            case 1: return "Meerkeuze";
            case 2: return "Match de juiste opties";
            case 3: return "Waar/Niet Waar";
            case 4: return "Volgorde";
            case 5: return "Afbeelding beoordeling";
            case 6: return "Open vraag";
            default: return "Onbekend type";
        }
    }
    const handleCollapse = (index) => {
        setCollapsedIndexes(prev => ({ ...prev, [index]: !prev[index] }) );
    }
    useEffect(() => {
        const initial = {};
        exercises.forEach((_, idx) => { initial[idx] = true });
        setCollapsedIndexes(initial);
    }, [exercises]);
    console.log("exercises", exercises);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const isMobile = windowWidth < 768;

    useEffect(() => {
        const onResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);
    return (
            <VerticalLayout className={`page-in-animation phone-review phone-review-content ${pageSwap ? "page-out-animation" : ""}`} style={{ gap: "1rem", minHeight:isMobile ? "20rem" : "40rem", maxHeight:isMobile ? "20rem" : "unset", overflow: "auto" }}>
                {errorScoreMessage && (<Alert marginTop={"1rem"} type={"error"} message={errorScoreMessage} />)}
                {!errorScoreMessage && !loading && scoreData.done === true && (<ScoreOverview data={scoreData} title={"Toets resultaat"} exercises={exercises} />)}
                {scoreData.done === true && exercises.map((exercise, index) => {
                    const isPassed = exercise.passed === true;
                    return (
                        <VerticalLayout key={index} className={`review-container ${collapsedIndexes[index] ? "collapsed" : ""} ${isPassed ? "passed" : "failed"}`}  onClick={() => handleCollapse(index)}>
                            <HorizontalLayout className="space-between review-header">
                                <HorizontalLayout className="review-title-group">
                                    <IconAtom onClick={() => handleCollapse(index)} iconSize={20} color={`review-status ${isPassed ? "correct" : "incorrect"}`} icon2={isPassed ? "check" : "x"} />
                                    <TitleAtom className={"standard-text-color outside-title"} title={`Vraag ${index + 1} (${getQuizTypeName(exercise.quiz_type)})`} />
                                </HorizontalLayout>
                                <IconButton icon2={collapsedIndexes[index] ? "chevron-up" : "chevron-down"} onClick={() => handleCollapse(index)}/>
                            </HorizontalLayout>
                            <ReviewFactory exercise={exercise} />
                        </VerticalLayout>
                    );
                })}
            </VerticalLayout>
    );
}



